
$(document).ready(function () {

    function parseDate(s) {
        var date = moment(s).toDate();
        return date;
    }

    function formatDate(date) {
        return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
    }

    // Helper function to concatinate string
    function substring(s, length = 220) {
        if (s && typeof s == 'string') {
            if (s.length > length) {
                return s.substring(0, length) + '...';
            }
            return s;
        }
        return '';
    }

    /**
     *  GENERAL USERS TABLE
     */
    $('#user-missions').DataTable({
        searching: false,
        serverSide: false,
        processing: true,
        ajax: '/missions?filter=assigned',
        columns: [
            {
                data: 'date_start',
                render: function (data, type, row, meta) {
                    return formatDate(parseDate(data));
                },
            },
            { data: 'mission' },
            {
                data: 'objective',
                render: function (data, type, row, meta) {
                    return substring(data);
                }
            },
            { data: 'mission_status' },
            { data: 'pilot_name' },
            {
                data: function (row, type, set, meta) {
                    return `<a href="/portal/missions/details/${row['id']}" class="btn btn-primary" data-id='${row['id']}'>View Details</a>`;

                }, orderable: false, searchable: false
            }
        ],
        initComplete: function (settings, json) {
            $('.nav-link[href="#upcomingMissions"] .tab-nav__num').text(json.recordsTotal);
        }
    });
    $('#user-missions-unassigned').DataTable({
        searching: false,
        serverSide: false,
        processing: true,
        ajax: '/missions?filter=unassigned',
        columns: [
            {
                data: 'date_start',
                render: function (data, type, row, meta) {
                    return formatDate(parseDate(data));
                },
            },
            { data: 'mission' },
            {
                data: 'objective',
                render: function (data, type, row, meta) {
                    return substring(data);
                }
            },
            { data: 'mission_status' },
            {
                data: function (row, type, set, meta) {
                    return `<button type="button" class="btn btn-primary" data-toggle="modal" data-target="#modal-missions" data-id='${row['id']}'>View Details</button>`;

                }, orderable: false, searchable: false
            }
        ],
        initComplete: function (settings, json) {
            $('.nav-link[href="#openMissions"] .tab-nav__num').text(json.recordsTotal);
        }
    });
    $('#user-missions-completed').DataTable({
        searching: false,
        serverSide: false,
        processing: true,
        ajax: '/missions?filter=completed',
        columns: [
            {
                data: 'date_start',
                render: function (data, type, row, meta) {
                    return formatDate(parseDate(data));
                },
            },
            { data: 'mission' },
            {
                data: 'objective',
                render: function (data, type, row, meta) {
                    return substring(data);
                }
            },
            { data: 'mission_status' },
            { data: 'pilot_name' },
            {
                data: function (row, type, set, meta) {
                    return `<button type="button" class="btn btn-primary" data-toggle="modal" data-target="#modal-missions" data-id='${row['id']}'>View Details</button>`;

                }, orderable: false, searchable: false
            }
        ],
        initComplete: function (settings, json) {
            $('.nav-link[href="#completedMissions"] .tab-nav__num').text(json.recordsTotal);
        }
    });
    $('#user-missions-closed').DataTable({
        searching: false,
        serverSide: false,
        processing: true,
        ajax: '/missions?filter=closed',
        columns: [
            {
                data: 'date_start',
                render: function (data, type, row, meta) {
                    return formatDate(parseDate(data));
                },
            },
            { data: 'mission' },
            {
                data: 'objective',
                render: function (data, type, row, meta) {
                    return substring(data);
                }
            },
            { data: 'mission_status' },
            { data: 'pilot_name' },
            {
                data: function (row, type, set, meta) {
                    return `<button type="button" class="btn btn-primary" data-toggle="modal" data-target="#modal-missions" data-id='${row['id']}'>View Details</button>`;

                }, orderable: false, searchable: false
            }
        ],
        initComplete: function (settings, json) {
            $('.nav-link[href="#closedMissions"] .tab-nav__num').text(json.recordsTotal);
        }
    });
    $('#pilot-missions').DataTable({
        searching: false,
        serverSide: false,
        processing: true,
        ajax: '/missions-all',
        columns: [
            {
                data: 'date_start',
                render: function (data, type, row, meta) {
                    return formatDate(parseDate(data));
                },
            },
            {
                data: 'objective',
                render: function (data, type, row, meta) {
                    return substring(data);
                }
            },
            { data: 'status' },
            {
                data: function (row, type, set, meta) {
                    return `<button type="button" class="btn btn-primary" data-toggle="modal" data-target="#modal-missions" data-id='${row['id']}'>View Details</button>`;

                }, orderable: false, searchable: false, width: '1px'
            }
        ],
        initComplete: function (settings, json) {
            $('.nav-link[href="#upcomingMissions"] .tab-nav__num').text(json.recordsTotal);
        }
    });
    $('#user-all-missions').DataTable({
        searching: false,
        serverSide: false,
        processing: true,
        ajax: '/missions-all',
        columns: [
            {
                data: 'date_start',
                render: function (data, type, row, meta) {
                    return formatDate(parseDate(data));
                },
            },
            { data: 'company' },
            { data: 'mission' },
            { data: 'status' },
            {
                data: function (row, type, set, meta) {
                    return `<button type="button" class="btn btn-primary" data-toggle="modal" data-target="#modal-missions" data-id='${row['id']}'>View Details</button>`;

                }, orderable: false, searchable: false
            }
        ],
        initComplete: function (settings, json) {
            $('.nav-link[href="#upcomingMissions"] .tab-nav__num').text(json.recordsTotal);
        }
    });
    /**
     *
     * CLIENT MISSION VARIATIONS
     *
     */
    $('#client-dashboard-missions-upcoming').DataTable({
        searching: false,
        serverSide: false,
        processing: true,
        ajax: '/missions?filter=upcoming',
        columns: [
            {
                data: 'date_start',
                render: function (data, type, row, meta) {
                    return formatDate(parseDate(data));
                },
            },
            { data: 'mission' },
            {
                data: 'objective',
                render: function (data, type, row, meta) {
                    return substring(data);
                }
            },
            { data: 'mission_status' },
            {
                data: function (row, type, set, meta) {
                    return `<button type="button" class="btn btn-primary" data-toggle="modal" data-target="#modal-missions" data-id='${row['id']}'>View Details</button>`;

                }, orderable: false, searchable: false
            }
        ],
        initComplete: function (settings, json) {
            $('.nav-link[href="#upcomingMissions"] .tab-nav__num').text(json.recordsTotal);
        }
    });
    $('#client-dashboard-missions-unassigned').DataTable({
        searching: false,
        serverSide: false,
        processing: true,
        ajax: '/missions?filter=unassigned',
        columns: [
            {
                data: 'date_start',
                render: function (data, type, row, meta) {
                    return formatDate(parseDate(data));
                },
            },
            { data: 'mission' },
            {
                data: 'objective',
                render: function (data, type, row, meta) {
                    return substring(data);
                }
            },
            { data: 'mission_status' },
            {
                data: function (row, type, set, meta) {
                    return `<button type="button" class="btn btn-primary" data-toggle="modal" data-target="#modal-missions" data-id='${row['id']}'>View Details</button>`;

                }, orderable: false, searchable: false
            }
        ],
        initComplete: function (settings, json) {
            $('.nav-link[href="#openMissions"] .tab-nav__num').text(json.recordsTotal);
        }
    });
    $('#client-missions-upcoming').DataTable({
        searching: false,
        serverSide: false,
        processing: true,
        ajax: '/missions?filter=upcoming',
        columns: [
            {
                data: 'date_start',
                render: function (data, type, row, meta) {
                    return formatDate(parseDate(data));
                },
            },
            { data: 'mission' },
            {
                data: 'objective',
                render: function (data, type, row, meta) {
                    return substring(data);
                }
            },
            { data: 'mission_status' },
            { data: 'city' },
            {
                data: function (row, type, set, meta) {
                    return `<button type="button" class="btn btn-primary" data-toggle="modal" data-target="#modal-missions" data-id='${row['id']}'>View Details</button>`;

                }, orderable: false, searchable: false
            }
        ],
        initComplete: function (settings, json) {
            $('.nav-link[href="#upcomingMissions"] .tab-nav__num').text(json.recordsTotal);
        }
    });
    $('#client-missions-unassigned').DataTable({
        searching: false,
        serverSide: false,
        processing: true,
        ajax: '/missions?filter=open',
        columns: [
            {
                data: 'date_start',
                render: function (data, type, row, meta) {
                    return formatDate(parseDate(data));
                },
            },
            { data: 'mission' },
            {
                data: 'objective',
                render: function (data, type, row, meta) {
                    return substring(data);
                }
            },
            { data: 'mission_status' },
            { data: 'city' },
            {
                data: function (row, type, set, meta) {
                    return `<button type="button" class="btn btn-primary" data-toggle="modal" data-target="#modal-missions" data-id='${row['id']}'>View Details</button>`;

                }, orderable: false, searchable: false
            }
        ],
        initComplete: function (settings, json) {
            $('.nav-link[href="#openMissions"] .tab-nav__num').text(json.recordsTotal);
        }
    });
    $('#client-missions-closed').DataTable({
        searching: false,
        serverSide: false,
        processing: true,
        ajax: '/missions?filter=closed',
        columns: [
            {
                data: 'date_start',
                render: function (data, type, row, meta) {
                    return formatDate(parseDate(data));
                },
            },
            { data: 'mission' },
            {
                data: 'objective',
                render: function (data, type, row, meta) {
                    return substring(data);
                }
            },
            { data: 'mission_status' },
            { data: 'city' },
            {
                data: function (row, type, set, meta) {
                    return `<button type="button" class="btn btn-primary" data-toggle="modal" data-target="#modal-missions" data-id='${row['id']}'>View Details</button>`;

                }, orderable: false, searchable: false
            }
        ],
        initComplete: function (settings, json) {
            $('.nav-link[href="#closedMissions"] .tab-nav__num').text(json.recordsTotal);
        }
    });


    /**
     *  ADMIN PILOTS
     */
    $('#admin-pilots-new').DataTable({
        searching: false,
        serverSide: false,
        processing: true,
        ajax: '/admin/pilots?filter=new',
        columns: [
            {
                data: 'date_start',
                render: function (data, type, row, meta) {
                    return formatDate(parseDate(data));
                },
            },
            { data: 'company' },
            { data: 'pilot_first' },
            { data: 'pilot_last' },
            { data: 'status' },
            {
                data: function (row, type, set, meta) {
                    return `
                <div class="btn-group mb-2">
                    <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#modal-pilots" data-id='${row['id']}'>View Profile</button>
                    <button type="button" class="btn btn-primary dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true aria-expanded="false>
                        <span class="sr-only">Toggle Dropdown</span>
                    </button>
                    <div class="dropdown-menu">
                        <a href='/admin/edit/user/${row['id']}' class="dropdown-item">Edit Pilot</a>
                    </div>
                </div>
                `;
                }, orderable: false, searchable: false
            }
        ],
        initComplete: function (settings, json) {
            $('.nav-link[href="#first"] .tab-nav__num').text(json.recordsTotal);
        }
    });
    $('#admin-pilots-active').DataTable({
        searching: false,
        serverSide: false,
        processing: true,
        ajax: '/admin/pilots?filter=active',
        columns: [
            {
                data: 'date_start',
                render: function (data, type, row, meta) {
                    return formatDate(parseDate(data));
                },
            },
            { data: 'company' },
            { data: 'pilot_first' },
            { data: 'pilot_last' },
            { data: 'status' },
            {
                data: function (row, type, set, meta) {
                    return `
                <div class="btn-group mb-2">
                    <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#modal-pilots" data-id='${row['id']}'>View Profile</button>
                    <button type="button" class="btn btn-primary dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true aria-expanded="false>
                        <span class="sr-only">Toggle Dropdown</span>
                    </button>
                    <div class="dropdown-menu">
                        <a href='/admin/edit/user/${row['id']}' class="dropdown-item">Edit Pilot</a>
                    </div>
                </div>
                `;
                }, orderable: false, searchable: false
            }
        ],
        initComplete: function (settings, json) {
            $('.nav-link[href="#second"] .tab-nav__num').text(json.recordsTotal);
        }
    });
    $('#admin-pilots-inactive').DataTable({
        searching: false,
        serverSide: false,
        processing: true,
        ajax: '/admin/pilots?filter=inactive',
        columns: [
            {
                data: 'date_start',
                render: function (data, type, row, meta) {
                    return formatDate(parseDate(data));
                },
            },
            { data: 'company' },
            { data: 'pilot_first' },
            { data: 'pilot_last' },
            { data: 'status' },
            {
                data: function (row, type, set, meta) {
                    return `
                <div class="btn-group mb-2">
                    <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#modal-pilots" data-id='${row['id']}'>View Profile</button>
                    <button type="button" class="btn btn-primary dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true aria-expanded="false>
                        <span class="sr-only">Toggle Dropdown</span>
                    </button>
                    <div class="dropdown-menu">
                        <a href='/admin/edit/user/${row['id']}' class="dropdown-item">Edit Pilot</a>
                    </div>
                </div>
                `;
                }, orderable: false, searchable: false
            }
        ],
        initComplete: function (settings, json) {
            $('.nav-link[href="#third"] .tab-nav__num').text(json.recordsTotal);
        }
    });


    /**
     *  ADMIN CLIENTS
     */
    $('#admin-clients-new').DataTable({
        searching: false,
        serverSide: false,
        processing: true,
        ajax: '/admin/clients?filter=new',
        columns: [
            {
                data: 'created_at',
                render: function (data, type, row, meta) {
                    return formatDate(parseDate(data));
                },
            },
            { data: 'company' },
            { data: 'first_name' },
            { data: 'last_name' },
            { data: 'city' },
            { data: 'consent_form' },
            { data: 'status' },
            {
                data: function (row, type, set, meta) {
                    return `
                <div class="btn-group mb-2">
                    <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#modal-clients" data-id='${row['id']}'>View Profile</button>
                    <button type="button" class="btn btn-primary dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true aria-expanded="false>
                        <span class="sr-only">Toggle Dropdown</span>
                    </button>
                    <div class="dropdown-menu">
                        <a href='/admin/edit/user/${row['id']}' class="dropdown-item">Edit Client</a>
                    </div>
                </div>
                `;
                }, orderable: false, searchable: false
            }
        ],
        initComplete: function (settings, json) {
            $('.nav-link[href="#first"] .tab-nav__num').text(json.recordsTotal);
        }
    });
    $('#admin-clients-active').DataTable({
        searching: false,
        serverSide: false,
        processing: true,
        ajax: '/admin/clients?filter=active',
        columns: [
            {
                data: 'created_at',
                render: function (data, type, row, meta) {
                    return formatDate(parseDate(data));
                },
            },
            { data: 'company' },
            { data: 'contact_first' },
            { data: 'contact_last' },
            { data: 'city' },
            { data: 'consent_form' },
            { data: 'status' },
            {
                data: function (row, type, set, meta) {
                    return `
                <div class="btn-group mb-2">
                    <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#modal-clients" data-id='${row['id']}'>View Profile</button>
                    <button type="button" class="btn btn-primary dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true aria-expanded="false>
                        <span class="sr-only">Toggle Dropdown</span>
                    </button>
                    <div class="dropdown-menu">
                        <a href='/admin/edit/user/${row['id']}' class="dropdown-item">Edit Client</a>
                    </div>
                </div>
                `;
                }, orderable: false, searchable: false
            }
        ],
        initComplete: function (settings, json) {
            $('.nav-link[href="#second"] .tab-nav__num').text(json.recordsTotal);
        }
    });
    $('#admin-clients-inactive').DataTable({
        searching: false,
        serverSide: false,
        processing: true,
        ajax: '/admin/clients?filter=inactive',
        columns: [
            {
                data: 'created_at',
                render: function (data, type, row, meta) {
                    return formatDate(parseDate(data));
                },
            },
            { data: 'company' },
            { data: 'contact_first' },
            { data: 'contact_last' },
            { data: 'city' },
            { data: 'consent_form' },
            { data: 'status' },
            {
                data: function (row, type, set, meta) {
                    return `
                <div class="btn-group mb-2">
                    <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#modal-clients" data-id='${row['id']}'>View Profile</button>
                    <button type="button" class="btn btn-primary dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true aria-expanded="false>
                        <span class="sr-only">Toggle Dropdown</span>
                    </button>
                    <div class="dropdown-menu">
                        <a href='/admin/edit/user/${row['id']}' class="dropdown-item">Edit Client</a>
                    </div>
                </div>
                `;
                }, orderable: false, searchable: false
            }
        ],
        initComplete: function (settings, json) {
            $('.nav-link[href="#third"] .tab-nav__num').text(json.recordsTotal);
        }
    });


    /**
     *  ADMIN MISSIONS
     */
    $('#admin-missions-new').DataTable({
        searching: false,
        serverSide: false,
        processing: true,
        ajax: '/admin/missions?filter=new',
        columns: [
            {
                data: 'date_start',
                render: function (data, type, row, meta) {
                    return formatDate(parseDate(data));
                },
            },
            { data: 'mission' },
            {
                data: 'objective',
                render: function (data, type, row, meta) {
                    return substring(data);
                }
            },
            { data: 'status' },
            { data: 'pilot_name' },
            {
                data: function (row, type, set, meta) {
                    return `
                <div class="btn-group mb-2">
                    <button type="button" class="btn btn-primary w-100" data-toggle="modal" data-target="#modal-missions" data-id='${row['id']}'>View Missions</button>
                    <button type="button" class="btn btn-primary dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true aria-expanded="false>
                        <span class="sr-only">Toggle Dropdown</span>
                    </button>
                    <div class="dropdown-menu">
                        <a class="dropdown-item" href='/mission/edit/${row['id']}'>Edit Mission</a>
                    </div>
                </div>
                `;
                }, orderable: false, searchable: false
            }
        ],
        initComplete: function (settings, json) {
            $('.nav-link[href="#first"] .tab-nav__num').text(json.recordsTotal);
        }
    });
    $('#admin-missions-open').DataTable({
        searching: false,
        serverSide: false,
        processing: true,
        ajax: '/admin/missions?filter=open',
        columns: [
            {
                data: 'date_start',
                render: function (data, type, row, meta) {
                    return formatDate(parseDate(data));
                },
            },
            { data: 'mission' },
            {
                data: 'objective',
                render: function (data, type, row, meta) {
                    return substring(data);
                }
            },
            { data: 'status' },
            {
                data: function (row, type, set, meta) {
                    return `
                <div class="btn-group mb-2">
                    <button type="button" class="btn btn-primary w-100" data-toggle="modal" data-target="#modal-missions" data-id='${row['id']}'>View Missions</button>
                    <button type="button" class="btn btn-primary dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true aria-expanded="false>
                        <span class="sr-only">Toggle Dropdown</span>
                    </button>
                    <div class="dropdown-menu">
                        <a class="dropdown-item" href='/mission/edit/${row['id']}'>Edit Mission</a>
                    </div>
                </div>
                `;
                }, orderable: false, searchable: false
            }
        ],
        initComplete: function (settings, json) {
            $('.nav-link[href="#second"] .tab-nav__num').text(json.recordsTotal);
        }
    });
    $('#admin-missions-closed').DataTable({
        searching: false,
        serverSide: false,
        processing: true,
        ajax: '/admin/missions?filter=closed',
        columns: [
            {
                data: 'date_start',
                render: function (data, type, row, meta) {
                    return formatDate(parseDate(data));
                },
            },
            { data: 'mission' },
            {
                data: 'objective',
                render: function (data, type, row, meta) {
                    return substring(data);
                }
            },
            { data: 'status' },
            { data: 'pilot_name' },
            {
                data: function (row, type, set, meta) {
                    return `
                <div class="btn-group mb-2">
                    <button type="button" class="btn btn-primary w-100" data-toggle="modal" data-target="#modal-missions" data-id='${row['id']}'>View Missions</button>
                    <button type="button" class="btn btn-primary dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true aria-expanded="false>
                        <span class="sr-only">Toggle Dropdown</span>
                    </button>
                    <div class="dropdown-menu">
                        <a class="dropdown-item" href='/mission/edit/${row['id']}'>Edit Mission</a>
                    </div>
                </div>
                `;
                }, orderable: false, searchable: false
            }
        ],
        initComplete: function (settings, json) {
            $('.nav-link[href="#third"] .tab-nav__num').text(json.recordsTotal);
        }
    });

});
